module.exports = __webpack_public_path__ + "resources/img/img_gamebase_game3.a30c5489ff473a54af3b99429e1cc61b.jpg";